// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1Y3jw","sendOtp":"AuthorizeToLogin_sendOtp__1Nh-q"};